import { TApiFolder } from '../../api/endpoints/Folder';
import {
  FOLDERS_CREATE_COMPLETED,
  FOLDERS_FETCH_COMPLETED,
  FOLDERS_FETCH_FAILED,
  FOLDERS_FETCH_STARTED,
  ICreateFoldersCompletedAction,
  IFetchFoldersCompletedAction,
  IFetchFoldersFailedAction,
  IFetchFoldersStartedAction
} from '../action-creators/folders';

export type TFoldersState = {
  loading: boolean;
  loadedAt: null | number;
  error: null | Error;
  data: Array<TApiFolder>
};

const initialState = {
  loading: false,
  loadedAt: null,
  error: null,
  data: []
};

type TAllowedActions =
  IFetchFoldersStartedAction |
  IFetchFoldersCompletedAction |
  IFetchFoldersFailedAction |
  ICreateFoldersCompletedAction


const foldersReducer = (state: TFoldersState = initialState, action: TAllowedActions): TFoldersState => {
  switch (action.type) {
    case FOLDERS_FETCH_STARTED:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FOLDERS_FETCH_COMPLETED:
      return {
        ...state,
        loadedAt: Date.now(),
        loading: false,
        error: null,
        data: action.data
      };

    case FOLDERS_FETCH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case FOLDERS_CREATE_COMPLETED:
      return {
        ...state,
        data: [...state.data, action.data]
      }

    default:
      return state;
  }
};

export default foldersReducer;
